import { useState } from 'react';
// @mui
import { Badge, Popover, IconButton } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsDropdownContent from './NotificationsDropdownContent';

import { getUserDetails } from '../../../utils';
import NotificationItem from './NotificationItem';

// ----------------------------------------------------------------------

export default function NotificationsPopover({ data }) {


  const userDetails = getUserDetails();

  const [open, setOpen] = useState(null);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const doesUnreadNotificationsExist = () => {
    const notifications = data?.data?.data?.notifications || data?.data?.data || [];
    if (!Array.isArray(notifications)) return 0;
    return notifications.filter(n => !n.isRead).length;
  };

  return (
    <>
      <IconButton
        color={open ? 'primary' : 'default'}
        onClick={handleOpen}
        sx={{
          width: 40,
          height: 40,
          bgcolor: 'primary.lighter',
          color: 'primary.main',
          '&:hover': {
            bgcolor: 'primary.light',
          },
        }}
      >
        <Badge
          badgeContent={doesUnreadNotificationsExist()}
          color="error"
          sx={{
            '& .MuiBadge-badge': {
              minWidth: '8px !important',
              borderRadius: '50%',
              p: '0',
              right: '5px',
              top: '3px',
              height: doesUnreadNotificationsExist() ? '20px' : '8px',
              width: doesUnreadNotificationsExist() ? '20px' : '8px',
            },
          }}
        >
          <NotificationsIcon sx={{ fontSize: 22 }} />
        </Badge>
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            mt: 1.5,
            ml: 0.75,
            width: 400,
            maxWidth: '90vw',
            borderRadius: 2,
          },
        }}
      >
        <NotificationsDropdownContent
          NotificationItem={NotificationItem}
          token={userDetails?.token}
          handleClose={handleClose}
          allNotificationsData={data?.data?.data?.notifications || data?.data?.data || []}
        />
      </Popover>
    </>
  );
}

// ----------------------------------------------------------------------


// ----------------------------------------------------------------------
